export default __webpack_public_path__ + "static/media/ray.7236f7f4.svg";